import { IconButton } from "@mui/material";
import ROLE from "enums/ROLE_NAME";
import WhiteLabelLogo from "features/AccountManagement/components/WhiteLabelLogo";
import useGetAccounts from "hooks/api/useGetAccounts";
import useGetSignedAccountLogoUrl from "hooks/api/useGetSignedAccountLogoUrl";
import useCurrentUser from "hooks/useCurrentUser";
import useProject from "hooks/useProject";
import { Link, useParams } from "react-router-dom";

export default function HomeButton() {
  const { accountId: accountIdFromParams } = useParams();
  const { accountId: accountIdFromProject, selfService } = useProject();
  const { role } = useCurrentUser();
  const accountIdFromContext = accountIdFromParams || accountIdFromProject;
  // Searchers have no :accountId / project — resolve membership via GET /accounts.
  const { accounts } = useGetAccounts({
    suspendRequest:
      Boolean(accountIdFromContext) || role !== ROLE.ACCOUNT_SEARCHER,
  });
  const accountId = accountIdFromContext || accounts[0]?.id;
  const { signedLogoUrl } = useGetSignedAccountLogoUrl(accountId);

  return (
    <IconButton
      component={Link}
      to={selfService && accountId ? `/account/${accountId}` : "/"}
    >
      <WhiteLabelLogo logoUrl={signedLogoUrl} />
    </IconButton>
  );
}
